import React from 'react'

export const DishDescription: React.FC<{description: string}> = ({description}) => {
  return (
    <p className="text-fontGray text-[14px] leading-[21px]">
      {description ?? ""}
    </p>
  )
}
